<template>
    <div class="home">页面开发中</div>
</template>

<script>
    // @ is an alias to /src

    export default {
        name: 'HomeView',
        components: {},
        beforeCreate() {
            console.log('beforeCreate- home view');
        },
    };
</script>
